export default __webpack_public_path__ + "static/media/IMG_1269.13a1c5e4.JPG";